import React, {useEffect, useState} from "react";
import {Layout, Breadcrumb, Button, Table, Space, Popconfirm, message, Modal, Form, Input, Select} from 'antd';
import Api from "../api";

const BASE_URL = '/admin/v2/recipe-category-messages';

const {Content} = Layout;

const RecipeCategoryMessages = () => {
    const [messages, setMessages] = useState([]);
    const [categories, setCategories] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingMessage, setEditingMessage] = useState(null);
    const [form] = Form.useForm();

    useEffect(() => {
        loadMessages();
        loadCategories();
    }, []);

    const loadMessages = () => {
        Api.get(BASE_URL).then(res => setMessages(res.data)).catch(err => message.error('Failed to load messages'));
    };

    const loadCategories = () => {
        Api.get('/admin/v2/recipe-categories').then(res => setCategories(res.data)).catch(err => message.error('Failed to load categories'));
    };

    const handleOk = () => {
        form.validateFields().then(values => {
            if (editingMessage) {
                Api.put(`${BASE_URL}/${editingMessage.id}`, values).then(() => {
                    message.success('Message updated');
                    setIsModalVisible(false);
                    loadMessages();
                });
            } else {
                Api.post(BASE_URL, values).then(() => {
                    message.success('Message created');
                    setIsModalVisible(false);
                    loadMessages();
                });
            }
        });
    };

    const editMessage = (message) => {
        setEditingMessage(message);
        form.setFieldsValue({
            name: message.name,
            content: message.content,
            category_ids: message.categories ? message.categories.map(c => c.id) : []
        });
        setIsModalVisible(true);
    };

    const deleteMessage = (id) => {
        Api.delete(`${BASE_URL}/${id}`).then(() => {
            message.success('Message deleted');
            loadMessages();
        });
    };

    const columns = [
        {title: 'ID', dataIndex: 'id', key: 'id'},
        {title: 'Name', dataIndex: 'name', key: 'name'},
        {title: 'Content', dataIndex: 'content', key: 'content', render: (text) => text && text.substring(0, 50) + '...'},
        {
            title: 'Categories',
            dataIndex: 'categories',
            key: 'categories',
            render: (categories) => categories ? categories.map(c => c.plural_name).join(', ') : ''
        },
        {
            title: 'Recipe Count',
            dataIndex: 'recipe_count',
            key: 'recipe_count',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space>
                    <Button onClick={() => editMessage(record)}>Edit</Button>
                    <Popconfirm title="Delete?" onConfirm={() => deleteMessage(record.id)}>
                        <Button danger>Delete</Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <Content style={{padding: '20px'}}>
            <Button type="primary" onClick={() => { setEditingMessage(null); form.resetFields(); setIsModalVisible(true); }}>Add Message</Button>
            <Table columns={columns} dataSource={messages} rowKey="id"/>
            <Modal title={editingMessage ? "Edit Message" : "Add Message"} visible={isModalVisible} onOk={handleOk} onCancel={() => setIsModalVisible(false)}>
                <Form form={form} layout="vertical">
                    <Form.Item name="name" label="Name" rules={[{required: true}]}><Input/></Form.Item>
                    <Form.Item name="content" label="Content" rules={[{required: true}]}><Input.TextArea/></Form.Item>
                    <Form.Item name="category_ids" label="Categories">
                        <Select mode="multiple" placeholder="Select categories">
                            {categories.map(c => <Select.Option key={c.id} value={c.id}>{c.plural_name}</Select.Option>)}
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        </Content>
    );
};

export default RecipeCategoryMessages;
